import { Model } from '@vuex-orm/core'
import Room from '@models/building/Room'

export default class Valve extends Model{
  static entity = 'valves'
  static fields () {
    return {
      id: this.uid(),
      roomId: this.attr(null),

      pipesAmmount: this.number(0),
      pipesystem: this.number(1),
      valvesAmmount: this.number(0),
      valvesPosition: this.number(3),

      changeablePipes: this.boolean(false)
    }
  }
} 